import { CommonModule }                       from '@angular/common';
import { NgModule }                           from '@angular/core';
import {
	FormsModule,
	ReactiveFormsModule
}                                             from '@angular/forms';
import { DateRangePickerFilterModule }        from '@shared/list-operations/components/datepicker-filters/date-range-picker-filter/date-range-picker-filter.module';
import { DatepickerFilterModule }             from '@shared/list-operations/components/datepicker-filters/datepicker-filter/datepicker-filter.module';
import { FilterComponent }                    from '@shared/list-operations/components/filter/filter.component';
import { ListFilterModule }                   from '@shared/list-operations/components/list-filter/list-filter.module';
import { OptionFilterModule }                 from '@shared/list-operations/components/option-filter/option-filter.module';
import { SelectFilterArchivingErsModule }     from '@shared/list-operations/components/select-filters/select-filter-archiving-ers/select-filter-archiving-ers.module';
import { SelectFilterArchivingKeywordModule } from '@shared/list-operations/components/select-filters/select-filter-archiving-keyword/select-filter-archiving-keyword.module';
import { SelectFilterArchivingTssModule }     from '@shared/list-operations/components/select-filters/select-filter-archiving-tss/select-filter-archiving-tss.module';
import { SelectFilterBusinessPremisesModule } from '@shared/list-operations/components/select-filters/select-filter-business-premises/select-filter-business-premises.module';
import { SelectFilterContractModule }         from '@shared/list-operations/components/select-filters/select-filter-contract/select-filter-contract.module';
import { SelectFilterErsModule }              from '@shared/list-operations/components/select-filters/select-filter-ers/select-filter-ers.module';
import { SelectFilterItemsModule }            from '@shared/list-operations/components/select-filters/select-filter-items/select-filter-items.module';
import { SelectFilterOrganizationModule }     from '@shared/list-operations/components/select-filters/select-filter-organization/select-filter-organization.module';
import { SelectFilterTenantModule }           from '@shared/list-operations/components/select-filters/select-filter-tenant/select-filter-tenant.module';
import { SelectFilterTssModule }              from '@shared/list-operations/components/select-filters/select-filter-tss/select-filter-tss.module';
import { SwitchFilterModule }                 from '@shared/list-operations/components/switch-filter/switch-filter.module';
import { TextFilterModule }                   from '@shared/list-operations/components/text-filter/text-filter.module';

@NgModule( {
	declarations: [
		FilterComponent
	],
	imports: [
		// Angular
		CommonModule,
		FormsModule,
		ReactiveFormsModule,

		// Shared ListOperations Filters
		// Date Filters
		DatepickerFilterModule,
		DateRangePickerFilterModule,

		// List Filter
		ListFilterModule,

		// Option Filter
		OptionFilterModule,

		// Select Filters
		SelectFilterArchivingErsModule,
		SelectFilterArchivingKeywordModule,
		SelectFilterArchivingTssModule,
		SelectFilterBusinessPremisesModule,
		SelectFilterContractModule,
		SelectFilterErsModule,
		SelectFilterItemsModule,
		SelectFilterOrganizationModule,
		SelectFilterTenantModule,
		SelectFilterTssModule,

		// Switch Filter
		SwitchFilterModule,

		// Text Filter
		TextFilterModule
	],
	exports: [
		FilterComponent
	]
} )
export class FilterModule {}
